<template>
	<div style="position: fixed; top: 0; width: 100%; z-index: 99999;">
		<header class="header-section">
			<div class="container-fluid p-0">
				<div class="header-wrapper">

					<div class="menu__left__wrap">
							<div class="logo-menu px-2">
								 <router-link to="/" class="logo">
									  <img src="@/assets/img/logo.png" alt="logo">
								 </router-link >
							</div>
							<router-link to="/" class="only-web header-top-list"><span>{{$store.state.lang.text.home[$store.state.lang.language]}}</span></router-link>
							<router-link to="/account/deposit" class="only-web header-top-list"><span>{{$store.state.lang.text.deposit[$store.state.lang.language]}}</span></router-link>
							<router-link to="/account/withdraw" class="only-web header-top-list"><span>{{$store.state.lang.text.withdraw[$store.state.lang.language]}}</span></router-link>
							<router-link to="/page/contact" class="only-web header-top-list"><span>{{$store.state.lang.text.contact[$store.state.lang.language]}}</span></router-link>
							<router-link to="/page/promotions" class="only-web header-top-list"><span>{{$store.state.lang.text.promotion[$store.state.lang.language]}}</span></router-link>
					  </div>

					  <div class="mneu-btn-grp" v-if="$store.state.authentication.loggedIn">
							<a class="cmn--btn" style="color: #FFF; cursor:pointer; padding: 9px 12px 12px" @click="changeL()">
								<div style="display: flex;align-items: center;" v-if="$store.state.lang.language == 0">
									<img src="@/assets/img/km.png" style="width: 18px">
									<span style="margin-left: 8px">ភាសាខ្មែរ</span>
								</div>
								<div style="display: flex;align-items: center;" v-if="$store.state.lang.language == 1">
									<img src="@/assets/img/en.png" style="width: 18px">
									<span style="margin-left: 8px">English</span>
								</div>
								<div style="display: flex;align-items: center;" v-if="$store.state.lang.language == 2">
									<img src="@/assets/img/cn.png" style="width: 18px">
									<span style="margin-left: 8px">中文</span>
								</div>
							</a>

							<router-link class="cmn--btn" v-if="loaded" to="/account/balance" style="background-color: #dab44f;">{{config.moneylify(balance)}}</span></router-link>
							<router-link class="cmn--btn only-web" to="/account" style="cursor: pointer;"><span>{{$store.state.lang.text.my_account[$store.state.lang.language]}}</span></router-link>
					  </div>

					  <div class="mneu-btn-grp" v-if="!$store.state.authentication.loggedIn">
							<a class="cmn--btn" style="color: #FFF; cursor:pointer; padding: 9px 12px 12px" @click="changeL()">
								<div style="display: flex;align-items: center;" v-if="$store.state.lang.language == 0">
									<img src="@/assets/img/km.png" style="width: 18px">
									<span style="margin-left: 8px">ភាសាខ្មែរ</span>
								</div>
								<div style="display: flex;align-items: center;" v-if="$store.state.lang.language == 1">
									<img src="@/assets/img/en.png" style="width: 18px">
									<span style="margin-left: 8px">English</span>
								</div>
								<div style="display: flex;align-items: center;" v-if="$store.state.lang.language == 2">
									<img src="@/assets/img/cn.png" style="width: 18px">
									<span style="margin-left: 8px">中文</span>
								</div>
							</a>

							<router-link to="/login" class="cmn--btn"><span>{{$store.state.lang.text.loginShort[$store.state.lang.language]}}</span></router-link>
							<router-link to="/register" class="cmn--btn2"><span>{{$store.state.lang.text.register[$store.state.lang.language]}}</span></router-link>
						</div>
				</div>
			</div>
	   </header>
		<div style="background-color: var(--body-color);padding: 3px 0 0px 0; font-size: 13px;">
			<marquee direction="left" scrollamount="3" behavior="scroll">📣 រីករាយដែលបានចូលមកកាន់ 98MBET យើងខ្ញុំជាក្រុមហ៊ុនហ្គេមកម្សាន្តដែលឈានមុខគេ ថែមទាំងផ្តល់ភាព ងាយស្រួល ជាមួយនិងការ ដក&ដាក់លុយរហ័ស ថែមទាំងមានទំនុកចិត្តខ្ពស់ទៀតផង !!!!</marquee>
		</div>
		<section class="main__tab__slide">
			<div style="width: 700px">
				<ul class="nav nav-tabs">
					<li class="nav-item" role="presentation">
						<router-link to="/bet/sport">
							<button class="nav-link">
								<img src="@/assets/img/icons/sport.png" style="width: 24px">
								<span>{{$store.state.lang.text.esport[$store.state.lang.language]}}</span>
							</button>
						</router-link>
					</li>
					<li class="nav-item" role="presentation">
						<router-link to="/bet/keno">
							<button class="nav-link">
								<img src="@/assets/img/icons/keno.png" style="width: 24px">
								<span>{{$store.state.lang.text.keno[$store.state.lang.language]}}</span>
							</button>
						</router-link>
					</li>
					<li class="nav-item" role="presentation">
						<router-link to="/bet/casino">
							<button class="nav-link">
								<img src="@/assets/img/icons/casino.png" style="width: 24px">
								<span>{{$store.state.lang.text.casino[$store.state.lang.language]}}</span>
							</button>
						</router-link>
					</li>
					<li class="nav-item" role="presentation">
						<router-link to="/bet/fishing">
							<button class="nav-link">
								<img src="@/assets/img/icons/fish.png" style="width: 24px">
								<span>{{$store.state.lang.text.fishing[$store.state.lang.language]}}</span>
							</button>
						</router-link>
					</li>
					<li class="nav-item" role="presentation">
						<router-link to="/bet/slot">
							<button class="nav-link">
								<img src="@/assets/img/icons/slot.png" style="width: 24px">
								<span>{{$store.state.lang.text.slot[$store.state.lang.language]}}</span>
							</button>
						</router-link>
					</li>
					<li class="nav-item" role="presentation">
						<router-link to="/bet/cock_fighting">
							<button class="nav-link">
								<img src="@/assets/img/icons/cock.png" style="width: 24px">
								<span>{{$store.state.lang.text.cock_fighting[$store.state.lang.language]}}</span>
							</button>
						</router-link>
					</li>
					<li class="nav-item" role="presentation">
						<router-link to="/page/promotions">
							<button class="nav-link">
								<img src="@/assets/img/icons/gift.png" style="width: 24px">
								<span>{{$store.state.lang.text.promotion[$store.state.lang.language]}}</span>
							</button>
						</router-link>
					</li>
				</ul>
			</div>
		</section>
	</div>
</template>
<script>
	export default {
		data() {
			return {
				balance: 0,
				loaded: false,
				interval: null,
				language: 0
			}
		},
		created() {
			this.getUser();
			this.language = this.$store.state.lang.language;
			this.interval = setInterval(() => {
				this.getUser();
			}, 5000)
		},
		beforeDestroy() {
			clearInterval(this.interval);
		},
		watch: {
			'$store.state.authentication.loggedIn': function() {
				this.getUser();
			},
		},
		methods: {
			getUser() {
				if(this.$store.state.authentication.loggedIn) {
					this.$http.get(this.config.api + "/user/authed/user/get_data").then(res => {
						if (res.body.status == 'success') {
							this.loaded = true;
							this.balance = res.body.data.balance + res.body.data.sport_balance + res.body.data.esport_balance + res.body.data.casino_balance + res.body.data.fishing_balance + res.body.data.slot_balance + res.body.data.keno_balance + res.body.data.cock_balance
							this.$store.state.authentication.username = res.body.data.username;
							this.$cookie.set('username', res.body.data.username, 1);
						}
					})
				}
			},
			changeL() {
				let current = this.$store.state.lang.language;

				let new_language = current + 1;
				if (new_language > 2) new_language = 0;
				this.$store.state.lang.language = parseInt(new_language);
				this.language = this.$store.state.lang.language;
				this.$cookie.set('language', this.language, 30);
			},
			// changeLanguage() {
			// 	let current = this.$store.state.lang.language;
			// 	let new_language = (current + 1) % 3;
			// 	this.$store.state.lang.language = new_language;
			// 	this.$cookie.set('language', new_language, 30);

			// }
		}
	}
</script>

<style>
	.select-language {
		border: 0;
		padding: 11px 0px 12px 10px;
		border-radius: 10px;
		background-color: #135F87;
		color: #FFF;
		font-size: 14px;
		font-family: 'Poppins', 'Koh Santepheap', sans-serif;
		font-weight: bold;
	}
	.select-language:focus {
		outline-width: 0 !important;
	}
	.select-language:focus-visible {
		outline-width: 0 !important;
	}
	@media (max-width: 944px) {
		.only-web {
			display: none !important;
		}
		.only-mobile {
			display: block !important;
		}
	}
	@media (min-width: 945px) {
		.only-web {
			display: block !important;
		}
		.only-mobile {
			display: none !important;
		}
	}

	.header-top-list {
		margin-right: 28px;
		font-weight: bold;
		cursor: pointer;
	}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue